/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Fast_Goat_LimpInputs */

const en_true_fast_goat_limp = /** @type {(inputs: True_Fast_Goat_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We found new patterns in your survey comments.`)
};

const de_true_fast_goat_limp = /** @type {(inputs: True_Fast_Goat_LimpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir haben neue Muster in Ihren Umfragekommentaren gefunden.`)
};

/**
* | output |
* | --- |
* | "We found new patterns in your survey comments." |
*
* @param {True_Fast_Goat_LimpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_fast_goat_limp = /** @type {((inputs?: True_Fast_Goat_LimpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Fast_Goat_LimpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_fast_goat_limp(inputs)
	return de_true_fast_goat_limp(inputs)
});